"use strict";
exports.__esModule = true;
exports.defaultRealm = exports.defaultBaseUrl = void 0;
exports.defaultBaseUrl = 'http://127.0.0.1:8080/auth';
exports.defaultRealm = 'master';
//# sourceMappingURL=constants.js.map